import * as links from '../../../constants/links';

export default [
  [`^/?$`, {
    title: 'Index Route',
    main: require('../../../components/pages/v2/IndexRoute'),
    v2: 1,
  }],
  [`^/?dashboard/?$`, {
    title: 'Dashboard',
    main: require('../../../components/pages/v2/Dashboard'),
    v2: 1,
  }],
  // [`^/?$`, () => {
  //   replaceLocation({
  //     path: links.LINK_DASHBOARD,
  //   });
  // }],

  [`^${links.LINK_INVOICE}/([^/]+):id$`, {
    title: 'Invoice',
    main: require('../../../components/pages/v2/InvoicePage'),
    v2: 1,
  }],

  [`^${links.LINK_TRANSACTIONS}/?$`, {
    title: 'Transactions',
    main: require('../../../components/pages/v2/Transactions'),
    v2: 1,
  }],
  [`^${links.LINK_TRANSACTION_DETAILS}/([^/]+):trxId?$`, {
    title: 'Transaction details',
    main: require('../../../components/pages/v2/TransactionPage'),
    v2: 1,
  }],

  [`^/?management/?$`, {
    title: 'Management',
    main: require('../../../components/pages/v2/Management'),
    v2: 1
  }],
  [`^${links.LINK_DEVELOPER_OPTIONS}/?$`, {
    title: 'Developer options',
    main: require('../../../components/pages/v2/DeveloperOptions'),
    v2: 1
  }],
  [`^${links.LINK_CREATE_APP}/?$`, {
    title: 'Create App',
    main: require('../../../components/pages/v2/DeveloperOptions/FormAppCreate'),
    v2: 1
  }],
  [`^${links.LINK_EDIT_APP}/([^/]+):appId?$`, {
    title: 'Edit App',
    main: require('../../../components/pages/v2/DeveloperOptions/FormAppEdit'),
    v2: 1
  }],
  [`^${links.LINK_APP}/([^/]+):appId?$`, {
    title: 'App Details',
    main: require('../../../components/pages/v2/DeveloperOptions/DetailsPage'),
    v2: 1
  }],
  [`^${links.LINK_DEVELOPER_OPTIONS}/([^/]+):appId${links.LINK_CRYPTO_WALLETS}/?$`, {
    title: 'Crypto Wallets List',
    main: require('../../../components/pages/v2/CryptoWallets'),
    v2: 1
  }],
  [`^${links.LINK_DEVELOPER_OPTIONS}/([^/]+):appId${links.LINK_CREATE_CRYPTO_WALLET}/?$`, {
    title: 'Create Crypto Wallet',
    main: require('../../../components/pages/v2/CryptoWallets/FormWalletCreate'),
    v2: 1
  }],
  [`^${links.LINK_DEVELOPER_OPTIONS}/([^/]+):appId${links.LINK_EDIT_CRYPTO_WALLET}/([^/]+):walletId?$`, {
    title: 'Edit Crypto Wallet',
    main: require('../../../components/pages/v2/DeveloperOptions/FormAppEdit'),
    v2: 1
  }],

  [`^/?settings/?$`, {
    title: 'Settings',
    main: require('../../../components/pages/v2/Settings'),
    v2: 1,
  }],


  [`^/?help/?$`, {
    title: 'Help and support',
    main: require('../../../components/pages/v2/HelpAndSupport'),
    v2: 1,
  }]
];
